module.exports = __webpack_public_path__ + "img/guifan3.5709d88d.jpg";